// extracted by mini-css-extract-plugin
export var bodySections = "_92-8";
export var gray = "_92-7";
export var green = "_92-4";
export var iconContainer = "_92-9";
export var iconWidgetContainer = "_92-1";
export var phoneIcon = "_92-2";
export var red = "_92-5";
export var statusDot = "_92-3";
export var widgetContainer = "_92-0";
export var yellow = "_92-6";